import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';

export const fetchCartera = createAsyncThunk('cartera/fetchCartera', async (filters, thunkAPI) => {
  // Asegurar que filters tenga un valor por defecto
  const filterParams = filters || {};
  try {
    // Construir parámetros de consulta
    const params = new URLSearchParams();

    // Agregar parámetros de filtro si existen
    if (filterParams.page) params.append('page', filterParams.page);
    if (filterParams.per_page) params.append('per_page', filterParams.per_page);
    if (filterParams.name) params.append('name', filterParams.name);
    if (filterParams.phone) params.append('phone', filterParams.phone);
    if (filterParams.proscai_id) params.append('proscai_id', filterParams.proscai_id);
    if (filterParams.store) params.append('store', filterParams.store);
    if (filterParams.manager) params.append('manager', filterParams.manager);

    // Si no hay filtros específicos, usar valores por defecto
    if (!params.toString()) {
      params.append('limit', '100');
    }

    console.log('params.toString()', params.toString());

    const response = await axiosInstance.get(`api/v1/collections/queryset-v2/?${params.toString()}`);
    console.log('response.data ', response.data);

    console.log('params.toString()', params.toString());
    console.log('response.data ', response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener data');
  }
});

export const fetchAssignManager = createAsyncThunk('cartera/fetchAssignManager', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`api/v1/collections/assign-manager/`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener data');
  }
});

export const fetchEmployees = createAsyncThunk('cartera/fetchEmployees', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`api/v1/control/employees/`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener empleados');
  }
});

export const fetchManager = createAsyncThunk('cartera/fetchManager', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`api/v1/control/list-managers/`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener empleados');
  }
});

export const fetchDespacho = createAsyncThunk('cartera/fetchDespacho', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`api/v1/control/employees/`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener empleados');
  }
});

// POST assign manager
export const assignManager = createAsyncThunk('cartera/assignManager', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`api/v1/collections/assign-manager/assign/`, payload);
    console.log('RESPONSE DATA response.data', response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al asignar gestor');
  }
});

// POST reassign manager
export const reassignManager = createAsyncThunk('cartera/assignManager', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`api/v1/collections/assign-manager/reassign-from-assignment/`, payload);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al asignar gestor');
  }
});

// POST assign manager
export const reassignClientManager = createAsyncThunk('cartera/reassignClientManager', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `api/v1/collections/assign-manager/assign-manager-client-onetoone/`,
      payload
    );
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al asignar gestor');
  }
});

export const fetchCastigados = createAsyncThunk('cartera/fetchCastigados', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`api/v1/collections/events-punishment/`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener castigados');
  }
});

const carteraSlice = createSlice({
  name: 'cartera',
  initialState: {
    cartera: [],
    managers: [],
    employees: [],
    castigados: [],
    loading: false,
    error: null,
    assignLoading: false,
    assignError: null,
    assignSuccess: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // punishment
      .addCase(fetchCastigados.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCastigados.fulfilled, (state, action) => {
        state.loading = false;
        state.castigados = action.payload;
      })
      .addCase(fetchCastigados.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCartera.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCartera.fulfilled, (state, action) => {
        state.loading = false;
        state.cartera = action.payload;
      })
      .addCase(fetchCartera.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Managers
      .addCase(fetchAssignManager.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssignManager.fulfilled, (state, action) => {
        state.loading = false;
        state.managers = action.payload;
      })
      .addCase(fetchAssignManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // employees
      .addCase(fetchEmployees.pending, (state) => {
        state.loadingEmployees = true;
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loadingEmployees = false;
        state.employees = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loadingEmployees = false;
        state.error = action.payload;
      })
      // manager
      .addCase(fetchManager.pending, (state) => {
        state.loadingEmployees = true;
        state.error = null;
      })
      .addCase(fetchManager.fulfilled, (state, action) => {
        state.loadingEmployees = false;
        state.employees = action.payload;
      })
      .addCase(fetchManager.rejected, (state, action) => {
        state.loadingEmployees = false;
        state.error = action.payload;
      })
      // despacho
      .addCase(fetchDespacho.pending, (state) => {
        state.loadingEmployees = true;
        state.error = null;
      })
      .addCase(fetchDespacho.fulfilled, (state, action) => {
        state.loadingEmployees = false;
        state.employees = action.payload;
      })
      .addCase(fetchDespacho.rejected, (state, action) => {
        state.loadingEmployees = false;
        state.error = action.payload;
      })
      // Assign manager
      .addCase(assignManager.pending, (state) => {
        state.assignLoading = true;
        state.assignError = null;
        state.assignSuccess = false;
      })
      .addCase(assignManager.fulfilled, (state, action) => {
        state.assignLoading = false;
        state.assignSuccess = true;
      })
      .addCase(assignManager.rejected, (state, action) => {
        state.assignLoading = false;
        state.assignError = action.payload;
        state.assignSuccess = false;
      })
      // reassignClientManager
      .addCase(reassignClientManager.pending, (state) => {
        state.assignLoading = true;
        state.assignError = null;
        state.assignSuccess = false;
      })
      .addCase(reassignClientManager.fulfilled, (state, action) => {
        state.assignLoading = false;
        state.assignSuccess = true;
      })
      .addCase(reassignClientManager.rejected, (state, action) => {
        state.assignLoading = false;
        state.assignError = action.payload;
        state.assignSuccess = false;
      });
  },
});

export default carteraSlice.reducer;
